import { EventEmitter } from 'events'

const notificationEvents = new EventEmitter()
export const EVENT_REQUEST_PERMISSION = 'requestPermission'

export default notificationEvents
